(function () {
  'use strict';

  const modificateHeader = () => {
    const mainHeader = document.querySelector(`.main-header`);
    const pageMain = document.querySelector(`.page-main`);
    const mainHeaderLogos = mainHeader.querySelector(`.main-header__logos`);
    const siteNav = mainHeader.querySelector(`.site-nav`);
    const siteNavList = siteNav.querySelector(`.site-nav__list`);

    if (mainHeader) {
      const updateHeader = () => {
        // pageMain.style.paddingTop = `${mainHeader.clientHeight}px`;

        const winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;

        // if (window.innerWidth <= 1024) {
        //   if (winScroll >= mainHeader.clientHeight) {
        //     siteNavList.style.maxHeight = `calc(100vh - ${siteNav.clientHeight}px)`;
        //   } else {
        //     siteNavList.style.maxHeight = `calc(100vh - ${mainHeader.clientHeight}px)`;
        //   }
        // } else {
        //   siteNavList.style.maxHeight = `none`;
        // }

        if (winScroll >= mainHeader.clientHeight) {
          mainHeader.classList.add(`main-header--scrolled`);
          mainHeader.style.top = `-${mainHeaderLogos.clientHeight}px`;
        } else {
          mainHeader.classList.remove(`main-header--scrolled`);
          mainHeader.style.top = `0px`;
        }
      };

      updateHeader();
      window.addEventListener(`scroll`, updateHeader);
      window.addEventListener(`resize`, updateHeader);
      window.addEventListener(`click`, updateHeader);
    }
  };

  const formMobileMenu = () => {
    const siteNavButton = document.querySelector(`.site-nav__button`);
    const siteNavList = document.querySelector(`.site-nav__list`);

    const prepareMobileMenu = () => {
      if (window.innerWidth <= 1024) {
        siteNavList.classList.add(`site-nav__list--hidden`);
        siteNavButton.classList.remove(`site-nav__button--clicked`);
      } else {
        siteNavList.classList.remove(`site-nav__list--hidden`);
        siteNavButton.classList.add(`site-nav__button--clicked`);
      }
    };

    const onSiteNavButtonClick = () => {
      if (window.innerWidth <= 1024) {
        siteNavList.classList.toggle(`site-nav__list--hidden`);
        siteNavButton.classList.toggle(`site-nav__button--clicked`);
      }
    };

    prepareMobileMenu();
    siteNavButton.addEventListener(`click`, onSiteNavButtonClick);
    // window.addEventListener(`resize`, prepareMobileMenu);
  };

  const initiateLazyLoad = () => {
    return new LazyLoad({
      elements_selector: `.lazy`
    });
  };

  const initiateObjectfit = () => {
    objectFitImages();
  };

  const prepareScrollTop = () => {
    const siteBody = document.querySelector(`body`);
    const scrollTopButton = document.createElement(`button`);
    scrollTopButton.classList.add(`scroll-top`);
    scrollTopButton.classList.add(`scroll-top--hidden`);
    scrollTopButton.innerHTML = `Вверх`;

    scrollTopButton.addEventListener(`click`, (evt) => {
      evt.preventDefault();
      siteBody.scrollIntoView({
        behavior: `smooth`,
        block: `start`
      });
    });

    window.addEventListener(`scroll`, () => {
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (winScroll > document.querySelector(`.main-header`).clientHeight) {
        scrollTopButton.classList.remove(`scroll-top--hidden`);
      } else {
        scrollTopButton.classList.add(`scroll-top--hidden`);
      }
    });

    siteBody.appendChild(scrollTopButton);
  };

  const prepareStickyAside = () => {
    const siteNavList = document.querySelector(`.site-nav__list`);
    const sidebar = document.querySelector(`aside`);

    if (siteNavList && sidebar) {
      window.addEventListener(`scroll`, () => {
        sidebar.children[
          sidebar.children.length - 1
        ].style.top = `${siteNavList.clientHeight + 4}px`;
      });

      window.addEventListener(`resize`, () => {
        sidebar.children[
          sidebar.children.length - 1
        ].style.top = `${siteNavList.clientHeight + 4}px`;
      });

      Stickyfill.addOne(sidebar.children[sidebar.children.length - 1]);
    }
  };

  const progressLine = () => {
    const progressBar = document.querySelector(`.progress-line`);

    if (progressBar) {
      const scrollFunc = () => {
        const winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;
        const height =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;
        const scrolled = (winScroll / height) * 100;
        progressBar.style.width = scrolled + `%`;
      };

      window.addEventListener(`scroll`, scrollFunc);
    }
  };

  modificateHeader();
  formMobileMenu();
  initiateObjectfit();
  initiateLazyLoad();
  prepareStickyAside();
  prepareScrollTop();
  progressLine();

}());
